/* RESPONSIBLE TEAM: team-data-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { getSamlSignInErrorMessage } from 'embercom/lib/saml';

export default class SignInRoute extends Route {
  @service store;
  @service redirectService;
  @service iamService;
  @service notificationsService;
  @service regionService;

  beforeModel(transition) {
    this.iamService.boot();

    let errorCode = transition.to.queryParams.error_code;
    if (errorCode !== undefined) {
      let errorMessage = getSamlSignInErrorMessage(errorCode);
      this.notificationsService.notifyError(errorMessage, 0);
    }
  }

  model(params) {
    return this.store.findRecord('app-sign-in-configuration', params.app_id);
  }

  afterModel(model, transition) {
    if (model.signedInWithAuthorizedMethod === true) {
      if (window.location.origin === this.regionService.standaloneCopilotFrameBaseURL) {
        this.redirectService.redirect(`/standalone/copilot/login_success`, transition);
      } else {
        this.transitionTo('apps.app', model.id);
      }
    }
  }
}
